var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpArrow = function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.607 17.737V4.19l4.706 4.706c.473.473 1.25.473 1.723 0a1.208 1.208 0 0 0 0-1.71L9.256.405a1.208 1.208 0 0 0-1.71 0L.752 7.173a1.208 1.208 0 0 0 0 1.71 1.208 1.208 0 0 0 1.71 0L7.182 4.19v13.548c0 .667.545 1.213 1.212 1.213.668 0 1.213-.546 1.213-1.213Z",
    fill: "#362B24"
  })));
};
export default SvgUpArrow;